import { useEffect, useState } from "react";

/**
 * Pagination for an AppTable whose rows are all loaded in the browser.
 *
 *   const { pageRows, pagination } = useClientPagination(rows, filters);
 *   <AppTable rows={pageRows} {...pagination} />
 *
 * `resetKey` (e.g. the filters) sends the table back to page 1 when it changes.
 * AppTable only shows the pager above 20 rows.
 */
const useClientPagination = (rows = [], resetKey) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  useEffect(() => setPage(0), [resetKey]);

  // Stay on a page that exists when rows disappear (e.g. after a delete).
  const lastPage = Math.max(0, Math.ceil(rows.length / rowsPerPage) - 1);
  const current = Math.min(page, lastPage);

  return {
    pageRows: rows.slice(current * rowsPerPage, (current + 1) * rowsPerPage),
    pagination: {
      count: rows.length,
      page: current,
      rowsPerPage,
      onPageChange: (_, next) => setPage(next),
      onRowsPerPageChange: (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      },
    },
  };
};

export default useClientPagination;
